import React from 'react'
import PropTypes from 'prop-types'
import tw, { css, styled } from 'twin.macro'
import Layout from '../components/layout'
import Meta from '../components/meta'
import { graphql } from 'gatsby'
import axios from 'axios'
import qs from 'qs'
import filterLocale from '../components/utils/filter-locale'
import {
	StyledForm,
	HomeButtonRow,
	HomeButton,
	FieldRow,
	FieldWrap,
	Required,
	StyledError,
} from '../components/form/styles'
import { Formik } from 'formik'
import assign from 'lodash.assign'
import {
	flat,
	validationSwitch,
	validationSchema,
} from '../components/form/utils'
import FormFieldGroup from '../components/form/FormFieldGroup'
import FormFieldSingle from '../components/form/FormFieldSingle'
import PopUp from '../components/modal/forms'
import { Lottie } from '@lottie'
import { Field } from 'formik'
import { CustomCheckboxContainer, CustomCheckboxInput } from '@reach/checkbox'
import * as animationCheckbox from '../animations/checkbox.json'

const ContentsSection = tw.section`w-full bg-gray-200`
const ContentsContainer = tw.div`w-95 md:w-11/12 bg-white py-10 px-4 md:px-10 mx-auto border-l border-r border-gray-300 border-b rounded-b-lg mb-16`

const FormContainer = tw.div`flex flex-col items-center justify-center`
const FormTitle = tw.h1`font-display text-5xl md:text-6xl text-gray-700 font-bold text-center mb-3 md:mb-0`
const FormDescription = tw.p`font-display text-lg mb-4 text-gray-700 text-center`
const FormHelp = tw.small`font-display text-base mb-6 md:mb-12 text-gray-700 text-center`
const Reminder = styled.p`
	${tw`font-display py-2 text-black mb-3 text-sm`}
	
	> a {
		${tw`underline hover:no-underline font-bold`}
	}
`
const CheckboxContainer = styled(CustomCheckboxContainer)`
	${tw`flex items-center justify-center`}
	input {
		${tw`border-0 p-0 h-px w-px -m-px absolute overflow-hidden whitespace-nowrap `}
		clip: rect(0 0 0 0);
		clippath: inset(50%);
	}
`

const InnovativeIdeas = ({ data: { page, form }, ...props }) => {
	const hs = props.location.hash
	const hash = hs.length && hs[0] == '#' ? hs.replace(/^#/, '') : ''
	const ps = props.location.search
	const params =
		ps.length && ps[0] == '?' ? qs.parse(ps.replace(/^\?/, '')) : ''

	const [showPopUp, setShowPopUp] = React.useState(false)
	const openPopUp = () => setShowPopUp(true)
	const closePopUp = () => setShowPopUp(false)

	const locale = 'en-AU'

	const [{ node }] = filterLocale(page.edges, locale)
	const { seoTitle, seoKeywords, seoDescription } = node

	const [{ node: nodeForm }] = filterLocale(form.edges, locale)
	const {
		title: formTitle,
		description: formDescription,
		items: formItems,
	} = nodeForm

	const valuesMapped = flat(formItems).map(item => ({
		[item.inputName]: '',
	}))
	valuesMapped.push({ readandagree: false })
	const validationMapped = flat(formItems).map(item => ({
		[item.inputName]: validationSwitch(item.inputName, item.validationText),
	}))
	validationMapped.push({ readandagree: validationSwitch('readandagree') })
	/** New Object from mapped Array */
	const valuesObject = assign({}, ...valuesMapped)
	const validationObject = assign({}, ...validationMapped)

	return (
		<Layout>
			<Meta
				title={seoTitle}
				keywords={seoKeywords}
				description={seoDescription}
			/>
			<ContentsSection id="innovative-ideas">
				<ContentsContainer>
					<FormContainer>
						<FormTitle>{formTitle}</FormTitle>
						<FormDescription>{formDescription}</FormDescription>
						<FormHelp>
							<b>NOTE</b>: This form is for employees only. If you are a
							customer and <br />
							have any questions, please email customercareau@maytronics.com.au.
							<br />
							Please email any supporting documents to hr.au@maytronics.com
						</FormHelp>
						<Formik
							initialValues={valuesObject}
							validationSchema={validationSchema(validationObject)}
							onSubmit={async (values, { setSubmitting, resetForm }) => {
								setSubmitting(true)
								axios.post('/.netlify/functions/graphql', {
									query: `
								      mutation createForm(
								        $formName: String!
								        $name: String
								        $email: String
												$type: String
												$department: String
								        $subject: String
								        $message: String
								      ) {
								        createForm(
								          formName: $formName
								          name: $name
								          email: $email
													type: $type
													department: $department
								          subject: $subject
								          message: $message
								        ) {
								          _id
								          formName
								          name
													email
													type
								          department
								          subject
								          message
								        }
								      }
								    `,
									variables: {
										formName: 'innovative-ideas',
										name: `${values.firstName} ${values.lastName}`,
										...values,
									},
								})
								resetForm()
								setSubmitting(false)
								return openPopUp()
							}}
						>
							{({ isSubmitting, errors, touched, values }) => (
								<StyledForm>
									{formItems.map((item, index) => {
										if (item.items) {
											const { title, items } = item
											return (
												<FormFieldGroup
													key={title + index}
													// color="#fff"
													{...{ items, errors, touched, values }}
												/>
											)
										} else {
											return (
												<FormFieldSingle
													key={item.inputName + index}
													overrideWidth="full"
													// color="#fff"
													{...{
														item: { ...item, helpText: null },
														errors,
														touched,
														values,
													}}
												/>
											)
										}
									})}
									<FieldRow>
										<FieldWrap>
											<Field name="readandagree" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex w-full mb-4 items-center">
														<CheckboxContainer
															tw="w-6 h-6 cursor-pointer rounded-sm mr-2"
															onClick={() =>
																setFieldValue(
																	'readandagree',
																	field.checked ? false : true
																)
															}
															onKeyDown={() =>
																setFieldValue(
																	'readandagree',
																	field.checked ? false : true
																)
															}
														>
															<CustomCheckboxInput
																{...field}
																checked={field.checked}
																name="readandagree"
																type="checkbox"
															/>
															<Lottie
																playingState={'playing'}
																speed={1}
																direction={field.checked ? 1 : -1}
																width={24}
																height={24}
																tw="bg-white rounded"
																className="lottie-container checkbox"
																config={{
																	animationData: animationCheckbox.default,
																	loop: false,
																	autoplay: true,
																	renderer: 'svg',
																}}
																aria-hidden
															/>
														</CheckboxContainer>
														<p tw="text-sm font-display">I have read and I agree to <a tw="font-bold underline hover:no-underline" href="/terms/" target="_blank">Maytronics Terms &#38; Conditions</a> and <a tw="font-bold underline hover:no-underline" href="/privacy/" target="_blank">Privacy Policy</a> <Required>*</Required></p>
													</div>
												)}
											</Field>
											{touched['readandagree'] && errors['readandagree'] ? (
												<StyledError>{`▲ ` + errors['readandagree']}</StyledError>
											) : (
												<></>
											)}
										</FieldWrap>
									</FieldRow>
									<FieldRow>
										<FieldWrap>
											<Field name="updates" type="checkbox">
												{({ field, form: { setFieldValue, setTouched } }) => (
													<div tw="flex w-full mb-4 items-center">
														<CheckboxContainer
															tw="w-6 h-6 cursor-pointer rounded-sm mr-2"
															onClick={() =>
																setFieldValue(
																	'updates',
																	field.checked ? false : true
																)
															}
															onKeyDown={() =>
																setFieldValue(
																	'updates',
																	field.checked ? false : true
																)
															}
														>
															<CustomCheckboxInput
																{...field}
																checked={field.checked}
																name="updates"
																type="checkbox"
															/>
															<Lottie
																playingState={'playing'}
																speed={1}
																direction={field.checked ? 1 : -1}
																width={24}
																height={24}
																tw="bg-white rounded"
																className="lottie-container checkbox"
																config={{
																	animationData: animationCheckbox.default,
																	loop: false,
																	autoplay: true,
																	renderer: 'svg',
																}}
																aria-hidden
															/>
														</CheckboxContainer>
														<p tw="text-sm font-display">I wish to receive updates and promotions from Maytronics.</p>
													</div>
												)}
											</Field>
										</FieldWrap>
									</FieldRow>
									<HomeButtonRow>
										<HomeButton type="submit" disabled={isSubmitting}>
											Send Message
										</HomeButton>
									</HomeButtonRow>
								</StyledForm>
							)}
						</Formik>
						<PopUp showDialog={showPopUp} close={closePopUp} />
					</FormContainer>
				</ContentsContainer>
			</ContentsSection>
		</Layout>
	)
}

export const InnovativeIdeasQuery = graphql`
	query innovativeIdeasQuery {
		page: allContentfulPage(
			filter: { contentful_id: { eq: "2UEcVsXQivqJJqSqeXofYa" } }
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
		form: allContentfulForm(
			filter: { contentful_id: { eq: "17uMH5EfB44y51Ro0AcZIg" } }
		) {
			edges {
				node {
					title
					description
					endpoint
					node_locale
					items {
						... on ContentfulFormField {
							helpText
							inputAutocomplete
							inputId
							inputName
							inputPlaceholder
							inputRequired
							inputType
							textareaCols
							textareaRows
							icon
							validationText
							width
							options
							node_locale
							label
						}
						... on ContentfulFormGroup {
							title
							items {
								width
								validationText
								textareaRows
								textareaCols
								options
								node_locale
								label
								inputType
								inputRequired
								inputPlaceholder
								inputName
								inputId
								inputAutocomplete
								icon
								helpText
							}
						}
					}
				}
			}
		}
	}
`
InnovativeIdeas.propTypes = {
	data: PropTypes.objectOf({
		page: PropTypes.arrayOf(PropTypes.object),
		form: PropTypes.arrayOf(PropTypes.object),
	}),
	location: PropTypes.object,
}
export default InnovativeIdeas
